import { axiosInstance, baseURL, handleErrors } from "./auth";

export const VERSION_LIST = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/version/list`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};

export const VERSION_UPDATE = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/version/update`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
